// import external dependencies
import "jquery";

// Import everything from autoload
import "./autoload/_bootstrap";
import "./modules/_gsap-animation.js"; import "./modules/_navbar.js"; import "./modules/_play-video.js"; import "./modules/_sliders.js"; import "./modules/_smooth-scroll.js"; import "./modules/general.js"; import "./modules/helpers.js";



// WEBPACK FOOTER //
// ./scripts/main.js